import { Subject, Observable } from 'rxjs';
import { bufferCount, map, startWith, withLatestFrom } from 'rxjs/operators';
import Modal from '@roo/roo/Modal';

import * as LX from '@utils/lxWrapper';

import doLogout from './doLogout';

const networkErrorDidalogOpenStatus$ = new Subject<boolean>();
const logonExpireDialogOpenStatus$ = new Subject<boolean>();

const takeCare = (requestState$: Observable<{ network: string; logon: string }>) => {
    requestState$
        .pipe(
            bufferCount(3, 1),
            map(latest3RequestStateHistory => {
                // 连续 3 次 HTTP 失败，则认为网络出现问题
                return latest3RequestStateHistory.every(state => state.network === 'error');
            }),
            withLatestFrom(networkErrorDidalogOpenStatus$.pipe(startWith(false))),
        )
        .subscribe(([isNetworkBroken, isNetworkErrorDialogOpen]) => {
            if (isNetworkBroken && !isNetworkErrorDialogOpen) {
                networkErrorDidalogOpenStatus$.next(true);
                Modal.confirm({
                    title: '网络异常',
                    children: '系统检测到网络连接异常，请检查网络连接后刷新页面',
                    onConfirm: () => {
                        window.location.reload();
                    },
                    onCancel: () => {
                        networkErrorDidalogOpenStatus$.next(false);
                    },
                    confirmText: '刷新页面',
                    cancelText: '忽略提醒',
                });
            }
        });

    requestState$
        .pipe(
            map(requestState => requestState.logon === 'error'),
            withLatestFrom(logonExpireDialogOpenStatus$.pipe(startWith(false))),
        )
        .subscribe(([isLogonBroken, isLogonErrorDialogOpen]) => {
            if (isLogonBroken && !isLogonErrorDialogOpen) {
                logonExpireDialogOpenStatus$.next(true);
                Modal.confirm({
                    title: '请重新登录',
                    children: '登录状态已经失效，10s后自动跳转登录页',
                    onConfirm: () => {
                        LX.reportMC('b_waimai_e_o9abz9q5_mc', 'c_waimai_e_p2x91l0m');
                        setTimeout(() => {
                            // Bye~
                            doLogout();
                        }, 500);
                    },
                    confirmText: '去登录页',
                    closable: false,
                    showCancelButton: false,
                    backdropClosable: false,
                });
                LX.reportMV('b_waimai_e_o9abz9q5_mv', 'c_waimai_e_p2x91l0m');
                setTimeout(() => {
                    // Bye~
                    doLogout();
                }, 1000 * 10);
            }
        });
};

export default { takeCare };
